import StackedbarOptions from "../stackedbar/StackedbarOptions";

export default class HorizontalStackedbarOptions extends StackedbarOptions {

}
